import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyKeywordDto, CompanyKeywordUpdateRequest } from '../../models/api/companyKeywordDto';

@Injectable({
  providedIn: 'root'
})
export class CompanyKeywordService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string): Observable<CompanyKeywordDto[]> {
    return this.http.get<CompanyKeywordDto[]>(`${this.apiUrl}/${companyId}/keywords`);
  }

  upsert(companyId: string, requests: CompanyKeywordUpdateRequest[]): Observable<CompanyKeywordDto[]> {
    return this.http.put<CompanyKeywordDto[]>(`${this.apiUrl}/${companyId}/keywords`, requests);
  }

  delete(companyId: string, keywordId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/keywords/${keywordId}`);
  }
}
